<template>
  <nav class="flex flex-wrap gap-2 mb-6 border-b border-gray-200 pb-3">
    <router-link
      v-for="link in navItems"
      :key="link.name"
      :to="{ name: link.name }"
      class="px-3 py-1.5 rounded-lg text-sm font-medium transition"
      :class="isActive(link) ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'"
    >
      {{ link.label }}
    </router-link>
  </nav>
</template>

<script>
export default {
  props: {
    extraActive: { type: String, default: null },
  },
  computed: {
    navItems() {
      return [
        { name: 'SmmToday', label: this.$t('smm.nav.today') },
        { name: 'SmmStats', label: this.$t('smm.nav.stats') },
        { name: 'SmmMarketingPlans', label: this.$t('smm.nav.marketing_plans') },
        { name: 'SmmNetworks', label: this.$t('smm.nav.networks') },
        { name: 'SmmSchedule', label: this.$t('smm.nav.schedule') },
        { name: 'SmmContent', label: this.$t('smm.nav.content') },
        { name: 'SmmKanban', label: this.$t('smm.nav.kanban') },
        { name: 'SmmBoard', label: this.$t('smm.nav.board') },
        { name: 'SmmSettingsChannels', label: this.$t('smm.nav.settings'), matchPrefix: 'SmmSettings' },
      ]
    },
  },
  methods: {
    isActive(link) {
      if (this.extraActive && this.$route.name === this.extraActive) {
        return link.name === 'SmmNetworks'
      }
      if (link.matchPrefix) {
        return String(this.$route.name || '').startsWith(link.matchPrefix)
      }
      return this.$route.name === link.name || this.$route.name === link.name + 'Detail'
    },
  },
}
</script>
